import * as _ from 'underscore';
import * as $ from 'jquery';

export const mimeTypes: { mime: string; ext: string }[] = [
    {
        mime: 'application/x-shockwave-flash',
        ext: 'swf'
    },
    {
        mime: 'application/pdf',
        ext: 'pdf'
    },
    {
        mime: 'video/x-msvideo',
        ext: 'avi'
    },
    {
        mime: 'text/csv',
        ext: 'csv'
    },
    {
        mime: 'application/x-msaccess',
        ext: 'mdb'
    },
    {
        mime: 'application/vnd.ms-excel',
        ext: 'xls'
    },
    {
        mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        ext: 'pptx'
    },
    {
        mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ext: 'xlsx'
    },
    {
        mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ext: 'docx'
    },
    {
        mime: 'application/vnd.ms-powerpoint',
        ext: 'ppt'
    },
    {
        mime: 'image/bmp',
        ext: 'bmp'
    },
    {
        mime: 'image/prs.btif',
        ext: 'btif'
    },
    {
        mime: 'image/cgm',
        ext: 'cgm'
    },
    {
        mime: 'image/x-cmx',
        ext: 'cmx'
    },
    {
        mime: 'image/vnd.dece.graphic',
        ext: 'uvi'
    },
    {
        mime: 'image/vnd.djvu',
        ext: 'djvu'
    },
    {
        mime: 'image/vnd.dwg',
        ext: 'dwg'
    },
    {
        mime: 'image/vnd.xiff',
        ext: 'xiff'
    },
    {
        mime: 'image/vnd.fpx',
        ext: 'fpx'
    },
    {
        mime: 'image/vnd.net-fpx',
        ext: 'npx'
    },
    {
        mime: 'image/x-freehand',
        ext: 'fh'
    },
    {
        mime: 'image/gif',
        ext: 'gif'
    },
    {
        mime: 'image/x-icon',
        ext: 'ico'
    },
    {
        mime: 'image/ief',
        ext: 'ief'
    },
    {
        mime: 'image/jpeg',
        ext: 'jpeg'
    },
    {
        mime: 'image/vnd.ms-modi',
        ext: 'mdi'
    },
    {
        mime: 'image/x-pcx',
        ext: 'pcx'
    },
    {
        mime: 'image/x-pict',
        ext: 'pic'
    },
    {
        mime: 'image/png',
        ext: 'png'
    },
    {
        mime: 'image/x-portable-pixmap',
        ext: 'ppm'
    },
    {
        mime: 'image/svg+xml',
        ext: 'svg'
    },
    {
        mime: 'image/tiff',
        ext: 'tiff'
    },
    {
        mime: 'image/webp',
        ext: 'webp'
    },
    {
        mime: 'image/vnd.dxf',
        ext: 'dxf'
    },
    {
        mime: 'application/octet-stream',
        ext: 'bin'
    },
    {
        mime: 'text/plain',
        ext: 'txt'
    },
    {
        mime: 'text/html',
        ext: 'html'
    },
    {
        mime: 'text/javascript',
        ext: 'js'
    },
    {
        mime: 'text/css',
        ext: 'css'
    },
    {
        mime: 'application/vnd.ms-fontobject',
        ext: 'eot'
    },
    {
        mime: 'application/x-font-sfnt',
        ext: 'ttf'
    },
    {
        mime: 'application/x-font-woff',
        ext: 'woff'
    }
];
